export const PHONE_VALIDATION_MESSAGE: string = 'Please enter 6 or more digits.';
export const PAYMENT_VALIDATION_MESSAGE: string = 'Phone number or email required for payment';
export const RECURRING_BOOKING_VALIDATION_MESSAGE: string = 'Phone number or email required for recurring bookings';
export const BOOKING_VALIDATION_MESSAGE: string = 'Phone number or email is mandatory';
export const SBL_EMAIL_VALIDATION_MESSAGE: string = 'Email is mandatory for Standby List';
export const SBL_SMSVALIDATION_MESSAGE: string = 'Phone number is mandatory for Standby List';

export const EMAIL_INVALID_MESSAGE: string = 'Please enter a valid email address';
export const EMAIL_REQUIRED_MESSAGE: string = 'Email is required';
export const EMAIL_TOO_LONG_MESSAGE: string = 'Email address is too long';
export const PHONE_ERROR_MESSAGE = 'Please enter a valid phone number.';

export const EXISTING_CUSTOMER_VALIDAITON_MESSAGE: string = 'Phone number or email required for existing customer';
export const CREATE_NEW_CUSTOMER_VALIDATION_MESSAGE: string = 'Phone or email present. Please create new customer';
